import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { downGradeOfferModalTexts } from 'src/common/config/TextMessage';
import { downGradeOfferModalSxs, infoModalSxs } from './newChangePlan';

interface OfferModalHeaderProps {
  isLocalSeo: boolean;
  isFromDeactivate: boolean;
  handleCloseDownGradeOfferModal: () => void;
}

const OfferModalHeader: React.FC<OfferModalHeaderProps> = ({
  isLocalSeo,
  isFromDeactivate,
  handleCloseDownGradeOfferModal
}) => {
  const getHeaderTitle = () => {
    if (isLocalSeo && isFromDeactivate) {
      return downGradeOfferModalTexts?.beforeCancel;
    }
    if (isFromDeactivate) {
      return downGradeOfferModalTexts?.beforeDeActivate;
    }
    return downGradeOfferModalTexts?.beforeDownGrade;
  };

  return (
    <Box sx={downGradeOfferModalSxs?.beforeDownGradeBoxSx}>
      <Typography sx={downGradeOfferModalSxs?.beforeDownGradeSx}>
        {getHeaderTitle()}
      </Typography>
      <IconButton
        aria-label="close"
        className="hover:rounded-lg"
        sx={infoModalSxs?.iconBtn}
        onClick={handleCloseDownGradeOfferModal}
      >
        <CloseIcon sx={{ color: 'var(--color-text-sidebar-icon) !important' }} />
      </IconButton>
    </Box>
  );
};

export default OfferModalHeader;
